export enum FileType {
  PNG = 'PNG',
  JPG = 'JPG',
  JPEG = 'JPEG',
  WEBP = 'WEBP',
  BMP = 'BMP',
  MP3 = 'MP3',
  PDF = 'PDF',
  MP4 = 'MP4',
  MPEG = 'MPEG',
  OTHER = 'OTHER',
}

export enum PatientFileType {
  OPG = 'OPG',
  COMPOSITE_VIEW = 'COMPOSITE_VIEW',
  MHF = 'MHF',
  CEPH = 'CEPH',
  CLINICAL_EXAM = 'CLINICAL_EXAM',
}

export type File = {
  id: string;
  name: string;
  type: FileType;
  size: number;
  url: string;
  extension: string;
  createdAt?: string;
};

export type PatientFile = {
  type: PatientFileType;
  file: File;
};

export type PatientFilesIdByType = { [key in Lowercase<keyof typeof PatientFileType>]: string[] };

export type uploadFilesInfoType = {
  id: string;
  fileExtension: string;
};

export type filesArrType = (File & { data: ArrayBuffer })[];
